import { ActivityList, Realm } from "../../../../api/types";
import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { asgmtDetailsStyle } from "./AssignmentResultsContent";
import { realmTopicMap } from "./topics";

interface DedupedRealmsProps {
	activities: ActivityList;
}

// remove redundant topics for each assignment
export const DedupedTopics: React.FC<DedupedRealmsProps> = ({
	activities,
}): JSX.Element => {
	// make each realm distinct
	const realmSet: Set<Realm> = new Set();
	if (activities) {
		activities.forEach((activity) => {
			realmSet.add(activity.realm);
		});
	}
	const dedupedRealmList = Array.from(new Set(realmSet)).sort();
	return (
		<View style={asgmtDetailsStyle.topicContainer}>
			{dedupedRealmList.map((realm, i) => {
				return (
					<View
						key={i}
						style={{
							flexDirection: "row",
							marginRight: 13,
							paddingVertical: 4,
							paddingHorizontal: 6.5,
							borderRadius: 10,
							backgroundColor: realmTopicMap[realm].color,
						}}
					>
						{realmTopicMap[realm].icon}
						<Text style={{ marginLeft: 2, fontSize: 12 }}>
							{realmTopicMap[realm].name}
						</Text>
					</View>
				);
			})}
		</View>
	);
};
